import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { benefits } from '../data/content';
import { SectionTitle } from './SectionTitle';
export function BenefitsSection() {
  return <section className="bg-white px-5 py-10 sm:px-8 lg:py-14" data-id="element-16" data-mp="3iqgcnq1vjtkv">
      <div className="mx-auto w-full max-w-content" data-id="element-17" data-mp="3ipya6bomcj4i">
        <SectionTitle align="left" className="max-w-prose" data-id="element-18" data-mp="3nohwid74jwxe">
          QUÉ RESULTADOS VAS A OBTENER...
        </SectionTitle>
        <ul className="mt-6 grid gap-3 lg:grid-cols-2" data-id="element-19" data-mp="38r8xqyfhrqvn">
          {benefits.map((benefit, i) => <li key={benefit} className={i === 4 ? 'lg:col-span-2' : ''} data-id="element-20" data-mp="3ds6f58soggw3" data-mpi={i}>
              <div className="flex h-full items-center gap-4 rounded-2xl border border-line bg-sage/50 px-6 py-5" data-id="element-21" data-mp="2zrvoo6va54bg">
                <ChevronRightIcon aria-hidden="true" className="h-6 w-6 shrink-0 text-[#4B7A58]" strokeWidth={2.5} data-id="element-22" data-mp="34pnjp9r816jv" />
                <p className="font-sans text-[17px] font-bold leading-snug text-ink" data-id="element-23" data-mp="y1ahozadt68u">
                  {benefit}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}